import React, { useContext, useEffect } from 'react';
import { AppSettings } from './../../config/app-settings.js';
import 'lity';
import 'lity/dist/lity.min.css';

function ExtraProfile() {
	const context = useContext(AppSettings);
	useEffect(() => {
		context.handleSetAppSidebarMinified(true);
		context.handleSetAppContentClass('p-0');
		return () => {
			context.handleSetAppSidebarMinified(false);
			context.handleSetAppContentClass('');
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<>
			
						
						<div className="profile">
							
							<div className="profile-header">
								<div className="profile-header-cover"></div>
								
								<div className="profile-header-content">
									<div className="profile-header-img">
										<img src="/color-admin/admin/react/assets/img/user/profile.jpg" className="object-fit-cover" alt="" />
									</div>
									<ul className="profile-header-tab nav nav-tabs nav-tabs-v2">
										<li className="nav-item">
											<a href="#profilePost" className="nav-link active" data-bs-toggle="tab">
												<div className="nav-field">Posts</div>
												<div className="nav-value">382</div>
											</a>
										</li>
										<li className="nav-item">
											<a href="#profileFollowers" className="nav-link" data-bs-toggle="tab">
												<div className="nav-field">Followers</div>
												<div className="nav-value">1.3m</div>
											</a>
										</li>
										<li className="nav-item">
											<a href="#profileMedia" className="nav-link" data-bs-toggle="tab">
												<div className="nav-field">Photos</div>
												<div className="nav-value">1,397</div>
											</a>
										</li>
										<li className="nav-item">
											<a href="#profileVideo" className="nav-link" data-bs-toggle="tab">
												<div className="nav-field">Videos</div>
												<div className="nav-value">120</div>
											</a>
										</li>
										<li className="nav-item">
											<a href="#profileFollowers" className="nav-link" data-bs-toggle="tab">
												<div className="nav-field">Following</div>
												<div className="nav-value">2,592</div>
											</a>
										</li>
									</ul>
								</div>
							</div>
							
							
							
							<div className="profile-container">
								
								<div className="profile-sidebar">
									<div className="desktop-sticky-top">
										
										<h4 className="mb-1">John Smith</h4>
										<div className="fw-semibold mb-3 text-secondary">@johnsmith</div>
										<p className="small fw-semibold">
											Principal UXUI Design & Brand Architecture for Studio. Creator of SeanTheme.
											Bringing the world closer together. Studied Computer Science and Psychology at Harvard University.
										</p>
										<div className="mb-2 fw-bold d-flex align-items-center gap-2 small2">
											<iconify-icon icon="solar:map-point-wave-bold-duotone" className="text-secondary text-opacity-75 fs-4"></iconify-icon>
											<span>New York, NY</span>
										</div>
										<div className="mb-2 fw-bold d-flex align-items-center gap-2 small2">
											<iconify-icon icon="solar:link-round-bold-duotone" className="text-secondary text-opacity-75 fs-4"></iconify-icon>
											<span>seantheme.com</span>
										</div>
										
										<hr className="my-4" />
										
										
										<div className="fw-bold mb-3">People to follow</div>
										<div className="d-flex align-items-center mb-2">
											<img src="/color-admin/admin/react/assets/img/user/user-1.jpg" alt="" width="36" className="rounded-circle" />
											<div className="flex-fill px-10px overflow-hidden">
												<div className="fw-bold text-truncate">Noor Rowe</div>
												<div className="fs-11px fw-semibold text-secondary">3.1m followers</div>
											</div>
											<a href="#/" className="btn btn-xs btn-light">Follow</a>
										</div>
										<div className="d-flex align-items-center mb-2">
											<img src="/color-admin/admin/react/assets/img/user/user-2.jpg" alt="" width="36" className="rounded-circle" />
											<div className="flex-fill px-10px overflow-hidden">
												<div className="fw-bold text-truncate">Abbey Parker</div>
												<div className="fs-11px fw-semibold text-secondary">302k followers</div>
											</div>
											<a href="#/" className="btn btn-xs btn-light">Follow</a>
										</div>
										<div className="d-flex align-items-center mb-2">
											<img src="/color-admin/admin/react/assets/img/user/user-3.jpg" alt="" width="36" className="rounded-circle" />
											<div className="flex-fill px-10px overflow-hidden">
												<div className="fw-bold text-truncate">Savannah Nicholson</div>
												<div className="fs-11px fw-semibold text-secondary">720k followers</div>
											</div>
											<a href="#/" className="btn btn-xs btn-light">Follow</a>
										</div>
										<div className="d-flex align-items-center mb-2">
											<img src="/color-admin/admin/react/assets/img/user/user-4.jpg" alt="" width="36" className="rounded-circle" />
											<div className="flex-fill px-10px overflow-hidden">
												<div className="fw-bold text-truncate">Kenny Bright</div>
												<div className="fs-11px fw-semibold text-secondary">1.4m followers</div>
											</div>
											<a href="#/" className="btn btn-xs btn-light">Follow</a>
										</div>
										<div className="d-flex align-items-center">
											<img src="/color-admin/admin/react/assets/img/user/user-5.jpg" alt="" width="36" className="rounded-circle" />
											<div className="flex-fill px-10px overflow-hidden">
												<div className="fw-bold text-truncate">Cara Poole</div>
												<div className="fs-11px fw-semibold text-secondary">989k followers</div>
											</div>
											<a href="#/" className="btn btn-xs btn-light">Follow</a>
										</div>
									</div>
								</div>
								
								
								
								<div className="profile-content">
									<div className="row">
										<div className="col-xl-8">
											<div className="tab-content p-0">
												
												<div className="tab-pane fade show active" id="profilePost">
													<div className="card border-0 rounded-3 mb-3">
														<div className="card-body">
															
															<div className="d-flex align-items-center mb-3">
																<a href="#/"><img src="/color-admin/admin/react/assets/img/user/profile.jpg" alt="" width="46" className="rounded-circle" /></a>
																<div className="flex-fill ps-10px">
																	<div className="fw-semibold"><a href="#/" className="text-decoration-none link-dark fw-bolder">Clyde Stanley</a> at <a href="#/" className="text-decoration-none fw-bold">South Lake Tahoe, California</a></div>
																	<div className="text-secondary small fw-semibold">March 16</div>
																</div>
															</div>
											
															
															<p>Best vacation of 2026</p>
															<div className="profile-img-list">
																<div className="profile-img-list-item main"><a href="/color-admin/admin/react/assets/img/gallery/gallery-1.jpg" data-lity="" className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: "url(/color-admin/admin/react/assets/img/gallery/gallery-1.jpg)" }}></span></a></div>
																<div className="profile-img-list-item"><a href="/color-admin/admin/react/assets/img/gallery/gallery-2.jpg" data-lity="" className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: "url(/color-admin/admin/react/assets/img/gallery/gallery-2.jpg)" }}></span></a></div>
																<div className="profile-img-list-item"><a href="/color-admin/admin/react/assets/img/gallery/gallery-3.jpg" data-lity="" className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: "url(/color-admin/admin/react/assets/img/gallery/gallery-3.jpg)" }}></span></a></div>
																<div className="profile-img-list-item"><a href="/color-admin/admin/react/assets/img/gallery/gallery-4.jpg" data-lity="" className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: "url(/color-admin/admin/react/assets/img/gallery/gallery-4.jpg)" }}></span></a></div>
																<div className="profile-img-list-item with-number">
																	<a href="/color-admin/admin/react/assets/img/gallery/gallery-5.jpg" data-lity="" className="profile-img-list-link">
																		<span className="profile-img-content" style={{ backgroundImage: "url(/color-admin/admin/react/assets/img/gallery/gallery-5.jpg)" }}></span>
																		<div className="profile-img-number">+12</div>
																	</a>
																</div>
															</div>
															<hr className="my-10px" />
															<div className="d-flex align-items-center fw-semibold">
																<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
																	<iconify-icon icon="solar:like-outline" className="fs-5"></iconify-icon>
																	Like
																</a>
																<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
																	<iconify-icon icon="solar:chat-square-outline" className="fs-5"></iconify-icon>
																	Comment
																</a> 
																<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
																	<iconify-icon icon="solar:square-forward-outline" className="fs-5"></iconify-icon>
																	Share
																</a>
															</div>
															<hr className="mt-10px mb-3" />
															<form action="" className="d-flex">
																<div><img src="/color-admin/admin/react/assets/img/user/profile.jpg" height="40" className="rounded-pill"  alt="" /></div>
																<div className="ps-2 flex-1 position-relative">
																	<input type="text" className="form-control shadow-none border-0 bg-body bg-opacity-50 rounded-pill h-100 ps-3" placeholder="Write a comment..." />
																	<div className="position-absolute top-0 end-0 bottom-0 px-3 d-flex align-items-center gap-2">
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:smile-circle-linear"></iconify-icon></a>
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:camera-linear"></iconify-icon></a>
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:videocamera-record-linear"></iconify-icon></a>
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:file-text-linear"></iconify-icon></a>
																	</div>
																</div>
															</form>
														</div>
													</div>
													<div className="card border-0 rounded-3 mb-3">
														<div className="card-body">
															
															<div className="d-flex align-items-center mb-3">
																<a href="#/"><img src="/color-admin/admin/react/assets/img/user/profile.jpg" alt="" width="46" className="rounded-circle" /></a>
																<div className="flex-fill ps-10px">
																	<div className="fw-semibold"><a href="#/" className="text-decoration-none link-dark fw-bolder">Clyde Stanley</a> is watching <a href="#/" className="text-decoration-none fw-bold">PATAGONIA 8k</a></div>
																	<div className="text-secondary small fw-semibold">March 12</div>
																</div>
															</div>
										
															
															<p>Nice PATAGONIA footage in 8K</p>
															
															<div className="ratio ratio-16x9">
										<iframe title="PATAGONIA 8K video" src="https://www.youtube.com/embed/ChOhcHD8fBA?showinfo=0"></iframe>
															</div>
													
															
															<hr className="my-10px" />
															<div className="d-flex align-items-center fw-semibold">
																<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
																	<iconify-icon icon="solar:like-outline" className="fs-5"></iconify-icon>
																	Like
																</a>
																<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
																	<iconify-icon icon="solar:chat-square-outline" className="fs-5"></iconify-icon>
																	Comment
																</a> 
																<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
																	<iconify-icon icon="solar:square-forward-outline" className="fs-5"></iconify-icon>
																	Share
																</a>
															</div>
															<hr className="mt-10px mb-3" />
															<form action="" className="d-flex">
																<div><img src="/color-admin/admin/react/assets/img/user/profile.jpg" height="40" className="rounded-pill"  alt="" /></div>
																<div className="ps-2 flex-1 position-relative">
																	<input type="text" className="form-control shadow-none border-0 bg-body bg-opacity-50 rounded-pill h-100 ps-3" placeholder="Write a comment..." />
																	<div className="position-absolute top-0 end-0 bottom-0 px-3 d-flex align-items-center gap-2">
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:smile-circle-linear"></iconify-icon></a>
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:camera-linear"></iconify-icon></a>
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:videocamera-record-linear"></iconify-icon></a>
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:file-text-linear"></iconify-icon></a>
																	</div>
																</div>
															</form>
														</div>
													</div>
													<div className="card border-0 rounded-3 mb-3">
														<div className="card-body">
															
															<div className="d-flex align-items-center mb-3">
																<a href="#/" className="text-decoration-none"><img src="/color-admin/admin/react/assets/img/user/profile.jpg" alt="" width="46" className="rounded-circle" /></a>
																<div className="flex-fill ps-10px">
																	<div className="fw-500"><a href="#/" className="text-decoration-none fw-bolder link-dark">Clyde Stanley</a></div>
																	<div className="text-secondary small fw-semibold">March 4</div>
																</div>
															</div>
										
															
															<p>
																Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />Quisque sodales urna justo, ac ultrices magna consectetur id.<br /><br />
																Donec tempor ligula sit amet nunc porta, sed aliquam leo sagittis.<br />
																Ut auctor congue efficitur. Praesent aliquam pulvinar neque, placerat semper massa elementum et.
															</p>
															
															
															<hr className="my-10px" />
															<div className="d-flex align-items-center fw-semibold">
																<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
																	<iconify-icon icon="solar:like-outline" className="fs-5"></iconify-icon>
																	Like
																</a>
																<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
																	<iconify-icon icon="solar:chat-square-outline" className="fs-5"></iconify-icon>
																	Comment
																</a> 
																<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
																	<iconify-icon icon="solar:square-forward-outline" className="fs-5"></iconify-icon>
																	Share
																</a>
															</div>
															<hr className="mt-10px mb-3" />
															<form action="" className="d-flex">
																<div><img src="/color-admin/admin/react/assets/img/user/profile.jpg" height="40" className="rounded-pill"  alt="" /></div>
																<div className="ps-2 flex-1 position-relative">
																	<input type="text" className="form-control shadow-none border-0 bg-body bg-opacity-50 rounded-pill h-100 ps-3" placeholder="Write a comment..." />
																	<div className="position-absolute top-0 end-0 bottom-0 px-3 d-flex align-items-center gap-2">
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:smile-circle-linear"></iconify-icon></a>
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:camera-linear"></iconify-icon></a>
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:videocamera-record-linear"></iconify-icon></a>
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:file-text-linear"></iconify-icon></a>
																	</div>
																</div>
															</form>
														</div>
													</div>
													<div className="card border-0 rounded-3 mb-3">
														<div className="card-body">
															
															<div className="d-flex align-items-center mb-3">
																<a href="#/"><img src="/color-admin/admin/react/assets/img/user/profile.jpg" alt="" width="50" className="rounded-circle" /></a>
																<div className="flex-fill ps-2">
																	<div className="fw-500"><a href="#/" className="text-decoration-none link-dark fw-bolder">Clyde Stanley</a> at <a href="#/" className="text-decoration-none">United States</a></div>
																	<div className="text-secondary small fw-semibold">May 5</div>
																</div>
															</div>
											
															
															<p>Business Trip</p>
															<div className="profile-img-list">
																<div className="profile-img-list-item main"><a href="/color-admin/admin/react/assets/img/gallery/gallery-5.jpg" data-lity="" className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: "url(/color-admin/admin/react/assets/img/gallery/gallery-5.jpg)" }}></span></a></div>
																<div className="profile-img-list-item main"><a href="/color-admin/admin/react/assets/img/gallery/gallery-6.jpg" data-lity="" className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: "url(/color-admin/admin/react/assets/img/gallery/gallery-6.jpg)" }}></span></a></div>
																<div className="profile-img-list-item"><a href="/color-admin/admin/react/assets/img/gallery/gallery-7.jpg" data-lity="" className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: "url(/color-admin/admin/react/assets/img/gallery/gallery-7.jpg)" }}></span></a></div>
																<div className="profile-img-list-item"><a href="/color-admin/admin/react/assets/img/gallery/gallery-8.jpg" data-lity="" className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: "url(/color-admin/admin/react/assets/img/gallery/gallery-8.jpg)" }}></span></a></div>
																<div className="profile-img-list-item"><a href="/color-admin/admin/react/assets/img/gallery/gallery-9.jpg" data-lity="" className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: "url(/color-admin/admin/react/assets/img/gallery/gallery-9.jpg)" }}></span></a></div>
																<div className="profile-img-list-item"><a href="/color-admin/admin/react/assets/img/gallery/gallery-10.jpg" data-lity="" className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: "url(/color-admin/admin/react/assets/img/gallery/gallery-10.jpg)" }}></span></a></div>
															</div>
															
															
															<hr className="my-10px" />
															<div className="d-flex align-items-center fw-semibold">
																<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
																	<iconify-icon icon="solar:like-outline" className="fs-5"></iconify-icon>
																	Like
																</a>
																<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
																	<iconify-icon icon="solar:chat-square-outline" className="fs-5"></iconify-icon>
																	Comment
																</a> 
																<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
																	<iconify-icon icon="solar:square-forward-outline" className="fs-5"></iconify-icon>
																	Share
																</a>
															</div>
															<hr className="mt-10px mb-3" />
															<form action="" className="d-flex">
																<div><img src="/color-admin/admin/react/assets/img/user/profile.jpg" height="40" className="rounded-pill"  alt="" /></div>
																<div className="ps-2 flex-1 position-relative">
																	<input type="text" className="form-control shadow-none border-0 bg-body bg-opacity-50 rounded-pill h-100 ps-3" placeholder="Write a comment..." />
																	<div className="position-absolute top-0 end-0 bottom-0 px-3 d-flex align-items-center gap-2">
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:smile-circle-linear"></iconify-icon></a>
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:camera-linear"></iconify-icon></a>
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:videocamera-record-linear"></iconify-icon></a>
																		<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:file-text-linear"></iconify-icon></a>
																	</div>
																</div>
															</form>
														</div>
													</div>
												</div>
												
												
												
												<div className="tab-pane fade" id="profileFollowers">
													<div className="list-group list-group-flush border-0 rounded">
														<div className="list-group-item d-flex p-10px align-items-center">
															<img src="/color-admin/admin/react/assets/img/user/user-1.jpg" alt="" width="46" className="rounded-2" />
															<div className="flex-fill ps-10px">
																<div><a href="#/" className="fw-bold link-dark text-decoration-none">Ethel Wilkes</a></div>
																<div className="text-secondary fw-semibold small">North Raundspic</div>
															</div>
															<a href="#/" className="btn btn-default">Follow</a>
														</div>
														<div className="list-group-item d-flex p-10px align-items-center">
															<img src="/color-admin/admin/react/assets/img/user/user-2.jpg" alt="" width="46" className="rounded-2" />
															<div className="flex-fill px-10px">
																<div><a href="#/" className="fw-bold link-dark text-decoration-none">Shanaya Hansen</a></div>
																<div className="text-secondary fw-semibold small">North Raundspic</div>
															</div>
															<a href="#/" className="btn btn-default">Follow</a>
														</div>
														<div className="list-group-item d-flex p-10px align-items-center">
															<img src="/color-admin/admin/react/assets/img/user/user-3.jpg" alt="" width="46" className="rounded-2" />
															<div className="flex-fill px-10px">
																<div><a href="#/" className="fw-bold link-dark text-decoration-none">James Allman</a></div>
																<div className="text-secondary fw-semibold small">North Raundspic</div>
															</div>
															<a href="#/" className="btn btn-default">Follow</a>
														</div>
														<div className="list-group-item d-flex p-10px align-items-center">
															<img src="/color-admin/admin/react/assets/img/user/user-4.jpg" alt="" width="46" className="rounded-2" />
															<div className="flex-fill px-10px">
																<div><a href="#/" className="fw-bold link-dark text-decoration-none">Marie Welsh</a></div>
																<div className="text-secondary fw-semibold small">Crencheporford</div>
															</div>
															<a href="#/" className="btn btn-default">Follow</a>
														</div>
														<div className="list-group-item d-flex p-10px align-items-center">
															<img src="/color-admin/admin/react/assets/img/user/user-5.jpg" alt="" width="46" className="rounded-2" />
															<div className="flex-fill px-10px">
																<div><a href="#/" className="fw-bold link-dark text-decoration-none">Lamar Kirkland</a></div>
																<div className="text-secondary fw-semibold small">Prince Ewoodswan</div>
															</div>
															<a href="#/" className="btn btn-default">Follow</a>
														</div>
														<div className="list-group-item d-flex p-10px align-items-center">
															<img src="/color-admin/admin/react/assets/img/user/user-6.jpg" alt="" width="46" className="rounded-2" />
															<div className="flex-fill px-10px">
																<div><a href="#/" className="fw-bold link-dark text-decoration-none">Bentley Osborne</a></div>
																<div className="text-secondary fw-semibold small">Red Suvern</div>
															</div>
															<a href="#/" className="btn btn-default">Follow</a>
														</div>
														<div className="list-group-item d-flex p-10px align-items-center">
															<img src="/color-admin/admin/react/assets/img/user/user-7.jpg" alt="" width="46" className="rounded-2" />
															<div className="flex-fill px-10px">
																<div><a href="#/" className="fw-bold link-dark text-decoration-none">Ollie Goulding</a></div>
																<div className="text-secondary fw-semibold small">Doa</div>
															</div>
															<a href="#/" className="btn btn-default">Follow</a>
														</div>
														<div className="list-group-item d-flex p-10px align-items-center">
															<img src="/color-admin/admin/react/assets/img/user/user-8.jpg" alt="" width="46" className="rounded-2" />
															<div className="flex-fill px-10px">
																<div><a href="#/" className="fw-bold link-dark text-decoration-none">Hiba Calvert</a></div>
																<div className="text-secondary fw-semibold small">Stemunds</div>
															</div>
															<a href="#/" className="btn btn-default">Follow</a>
														</div>
														<div className="list-group-item d-flex p-10px align-items-center">
															<img src="/color-admin/admin/react/assets/img/user/user-9.jpg" alt="" width="46" className="rounded-2" />
															<div className="flex-fill px-10px">
																<div><a href="#/" className="fw-bold link-dark text-decoration-none">Rivka Redfern</a></div>
																<div className="text-secondary fw-semibold small">Fallnee</div>
															</div>
															<a href="#/" className="btn btn-default">Follow</a>
														</div>
														<div className="list-group-item d-flex p-10px align-items-center">
															<img src="/color-admin/admin/react/assets/img/user/user-10.jpg" alt="" width="46" className="rounded-2" />
															<div className="flex-fill px-10px">
																<div><a href="#/" className="fw-bold link-dark text-decoration-none">Roshni Fernandez</a></div>
																<div className="text-secondary fw-semibold small">Mount Lerdo</div>
															</div>
															<a href="#/" className="btn btn-default">Follow</a>
														</div>
													</div>
													<div className="text-center p-3"><a href="#/" className="text-decoration-none link-dark fw-bold">Show more</a></div>
												</div>
												
												
												
												<div className="tab-pane fade" id="profileMedia">
													<div className="card border-0 mb-3">
														<div className="card-header fw-bold bg-transparent">May 20</div>
														<div className="card-body">
															<div className="rounded overflow-hidden">
																<div className="row gx-1 gy-1">
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-1.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-1.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-2.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-2.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-3.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-3.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-4.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-4.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-5.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-5.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-6.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-6.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-7.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-7.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-8.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-8.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-9.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-9.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-10.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-10.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-11.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-11.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-12.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-12.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																</div>
															</div>
														</div>
													</div>
													<div className="card border-0 mb-3">
														<div className="card-header fw-bold bg-transparent">May 16</div>
														<div className="card-body">
															<div className="rounded overflow-hidden">
																<div className="row gx-1 gy-1">
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-13.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-13.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-14.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-14.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-15.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-15.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-16.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-16.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-17.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-17.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-18.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-18.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-19.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-19.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-20.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-20.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-21.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-21.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-22.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-22.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-23.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-23.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-24.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-24.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-25.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-25.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-26.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-26.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-27.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-27.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-28.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-28.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-29.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-29.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																	<div className="col-lg-3 col-md-4 col-6"><a href="/color-admin/admin/react/assets/img/gallery/gallery-30.jpg" data-lity=""><img src="/color-admin/admin/react/assets/img/gallery/gallery-30.jpg" className="object-fit-cover w-100 h-150px"  alt="" /></a></div>
																</div>
															</div>
														</div>
													</div>
													<div className="text-center mb-3"><a href="#/" className="link-dark fw-semibold text-decoration-none">Show more</a></div>
												</div>
												
												
												
												<div className="tab-pane fade" id="profileVideo">
													<div className="card border-0 mb-3">
														<div className="card-header fw-bold bg-transparent">Collections #1</div>
														<div className="card-body">
															<div className="rounded overflow-hidden">
																<div className="row gx-1 gy-1">
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=RMX030skQ3Q" data-lity="">
																			<img src="https://img.youtube.com/vi/RMX030skQ3Q/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=I4pepBsOWfI" data-lity="">
																			<img src="https://img.youtube.com/vi/I4pepBsOWfI/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=ZtT3jaTcCsY" data-lity="">
																			<img src="https://img.youtube.com/vi/ZtT3jaTcCsY/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=j9G2l5ryJZY" data-lity="">
																			<img src="https://img.youtube.com/vi/j9G2l5ryJZY/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=I66_LmOTlSk" data-lity="">
																			<img src="https://img.youtube.com/vi/I66_LmOTlSk/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=6ihmk1Gv2i8" data-lity="">
																			<img src="https://img.youtube.com/vi/6ihmk1Gv2i8/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=VlTSdevWZeQ" data-lity="">
																			<img src="https://img.youtube.com/vi/VlTSdevWZeQ/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=3tVwEcc6WEE" data-lity="">
																			<img src="https://img.youtube.com/vi/3tVwEcc6WEE/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=0YEfe9bN8pw" data-lity="">
																			<img src="https://img.youtube.com/vi/0YEfe9bN8pw/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="card border-0 mb-3">
														<div className="card-header fw-bold bg-transparent">Collections #2</div>
														<div className="card-body">
															<div className="rounded overflow-hidden">
																<div className="row gx-1 gy-1">
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=Iv7BYURURRI" data-lity="">
																			<img src="https://img.youtube.com/vi/Iv7BYURURRI/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=yECD9TzmW-A" data-lity="">
																			<img src="https://img.youtube.com/vi/yECD9TzmW-A/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=jRzpagPx6uY" data-lity="">
																			<img src="https://img.youtube.com/vi/jRzpagPx6uY/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=KmEdcFcJUuo" data-lity="">
																			<img src="https://img.youtube.com/vi/KmEdcFcJUuo/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=E7AXalS3uX4" data-lity="">
																			<img src="https://img.youtube.com/vi/E7AXalS3uX4/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=OklNVNKftJ8" data-lity="">
																			<img src="https://img.youtube.com/vi/OklNVNKftJ8/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=5aJciQFtEQg" data-lity="">
																			<img src="https://img.youtube.com/vi/5aJciQFtEQg/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=OklNVNKftJ8" data-lity="">
																			<img src="https://img.youtube.com/vi/OklNVNKftJ8/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																	<div className="col-md-4 col-sm-6">
																		<a href="https://www.youtube.com/watch?v=BNEmDcQr6hk" data-lity="">
																			<img src="https://img.youtube.com/vi/BNEmDcQr6hk/mqdefault.jpg" alt="" className="d-block w-100 h-150px object-fit-cover" />
																		</a>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												
											</div>
										</div>
										<div className="col-xl-4">
											<div className="desktop-sticky-top d-none d-lg-block">
												<div className="card border-0 mb-3">
													<div className="list-group list-group-flush">
														<div className="list-group-item fw-bold px-3 d-flex align-items-center">
															<span className="flex-fill">Trends for you</span> 
															<a href="#/" className="text-secondary d-flex fs-5 my-n1"><iconify-icon icon="solar:settings-bold-duotone" className="fa-lg"></iconify-icon></a>
														</div>
														<div className="list-group-item px-3">
															<div className="text-secondary text-opacity-75 fw-bold small">Trending Worldwide</div>
															<div className="fw-bolder mb-2">#BreakingNews</div>
															<a href="#/" className="card overflow-hidden mb-2 text-body text-decoration-none border-0 bg-light">
																<div className="row">
																	<div className="col-md-8">
																		<div className="card-body py-10px px-3">
																			<div className="small fw-bold text-secondary text-opacity-75">Space</div>
																			<div className="fw-semibold lh-14">Distant star explosion is brightest ever seen, study finds</div>
																		</div>
																	</div>
																	<div className="col-md-4 d-flex">
																		<div className="h-100 w-100" style={{ background: "url(//color-admin/admin/react/assets/img/gallery/news-1.jpg) center", backgroundSize: "cover" }}></div>
																	</div>
																</div>
															</a>
															<div className="small text-secondary text-opacity-75 fw-semibold">1.89m share</div>
														</div>
														<div className="list-group-item px-3">
															<div className="fw-bolder mb-1">#TrollingForGood</div>
															<div className="fw-semibold mb-2">Be a good Troll and spread some positivity on Studio today.</div>
															<div className="small text-secondary text-opacity-75 fw-semibold">Promoted by Studio Trolls</div>
														</div>
														<div className="list-group-item px-3">
															<div className="text-secondary text-opacity-75 fw-bold small">Trending Worldwide</div>
															<div className="fw-bolder mb-1">#CronaOutbreak</div>
															<div className="fw-semibold mb-1">The coronavirus is affecting 210 countries around the world and 2 ...</div>
															<div className="small text-secondary text-opacity-75 fw-semibold">49.3m share</div>
														</div>
														<div className="list-group-item px-3">
															<div className="text-secondary text-opacity-75 fw-bold small">Trending in New York</div>
															<div className="fw-bold mb-2">#CoronavirusPandemic</div>
															<a href="#/" className="card overflow-hidden mb-2 text-body text-decoration-none border-0 bg-light">
																<div className="row no-gutters">
																	<div className="col-md-8">
																		<div className="card-body py-10px px-3">
																			<div className="small fw-bold text-secondary text-opacity-75">Coronavirus</div>
																			<div className="fw-semibold lh-14">Coronavirus: US suspends travel from Europe</div>
																		</div>
																	</div>
																	<div className="col-md-4 d-flex">
																		<div className="h-100 w-100" style={{ background: "url(/color-admin/admin/react/assets/img/gallery/news-2.jpg) center", backgroundSize: "cover" }}></div>
																	</div>
																</div>
															</a>
															<div className="small text-secondary text-opacity-75 fw-semibold">821k share</div>
														</div>
														<a href="#/" className="list-group-item list-group-action text-center fw-semibold">
															Show more
														</a>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								
							</div>
							
						</div>
						
					
		</>
	);
}

export default ExtraProfile;
